module.exports = __webpack_public_path__ + "img/icon-pse.6f032e4b.svg";